import { List, Create, Edit, Users } from "../Components/index.js";

export default [
    {
        path: "/admin/trades",
        component: List,
        name: "trades-list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/trades/:id/edit",
        component: Edit,
        name: "trades-edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/trades/create",
        component: Create,
        name: "trades-create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/trades/:trade_id/users",
        component: Users,
        name: "trades-users",
        meta: {
            requiresAuth: true,
        },
    },
];
